import {notification} from "antd";

export function successMessage(message) {
    let notificationParam = {
        message: 'Successo!'
    }
    notificationParam.description = message
    notification.success(notificationParam)
}

export function errorMessage(message) {
    let notificationParam = {
        message: 'Errore!'
    }
    notificationParam.description = message
    notification.error(notificationParam)
}

/**
 * Messaggio del primo campo che non ha passato la validazione. "Inserisci
 * tutti i campi obbligatori" e' fuorviante quando a fermare il salvataggio
 * non e' un campo vuoto ma una regola di coerenza, come il codice fiscale
 * che non torna con l'anagrafica.
 */
export function firstValidationError(info, fallback = 'Inserisci tutti i campi obbligatori!') {
    return info?.errorFields?.[0]?.errors?.[0] || fallback;
}

export function warningMessage(message) {
    let notificationParam = {
        message: 'Attenzione!'
    }
    notificationParam.description = message
    notification.warning(notificationParam)
}
